import { en } from './en';
import { de } from './de';

export type Locale = 'en' | 'de';
export type LocalePref = 'auto' | Locale;

export type Messages = Record<string, string>;

const DICTS: Record<Locale, Messages> = { en, de };

/** Resolve an `auto` preference to a concrete locale from the browser. */
export function resolveLocale(pref: LocalePref): Locale {
  if (pref === 'en' || pref === 'de') return pref;
  const nav = typeof navigator !== 'undefined' ? navigator.language : 'en';
  return nav.toLowerCase().startsWith('de') ? 'de' : 'en';
}

// Module-level active locale so the non-hook `t()` works everywhere (including
// outside React, e.g. command definitions). Kept in sync by the store.
let active: Locale = 'en';
export function setActiveLocale(l: Locale): void {
  active = l;
}
export function getActiveLocale(): Locale {
  return active;
}

/**
 * Translate `key` for the active locale, interpolating `{name}` params. Falls
 * back to English, then to the key itself, so a missing translation is visible
 * but never crashes.
 */
export function t(key: string, params?: Record<string, string | number>): string {
  const raw = DICTS[active][key] ?? en[key] ?? key;
  if (!params) return raw;
  return raw.replace(/\{(\w+)\}/g, (_, k: string) => String(params[k] ?? `{${k}}`));
}
